import {
    SETUP,
    LOGIN_USER_SUCCESS,
    LOGOUT,
    GET_USER_SETTINGS,
    UPDATE_USER_SETTINGS
} from './types';

import api from './api';

export const setup = () => {
    return {
        type: SETUP,
        payload: api.auth.setup(),
        meta: {
            onSuccess: data => {
                localStorage.setItem('permissions', JSON.stringify(data.permissions));
            }
        }
    };
};

export const login = ({ identity, password, token }) => {
    return {
        type: LOGIN_USER_SUCCESS,
        payload: api.auth.login({ identity, password }),
        meta: {
            dispatchOnSuccess: (payload) => {
                localStorage.setItem('token', payload.token);
                localStorage.setItem('permissions', JSON.stringify(payload.permissions));
                return setup();
            }
        }
    };
};

export const logout = () => {
    return {
        type: LOGOUT,
    };
};

export const getUserSettings = (userId) => {
    return {
        type: GET_USER_SETTINGS,
        payload: api.auth.settings.get(userId),
        meta: { userId }
    };
};

export const updateUserSettings = (user, onSuccess, onFailure) => {
    return {
        type: UPDATE_USER_SETTINGS,
        payload: api.auth.settings.update(user),
        meta: {
            userId: user.id,
            onSuccess,
            onFailure
        }
    };
};
